/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Editor } from '@squiz/component-editing-ui';
import { useUniqueId } from '@squiz/dxp-console-support';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { JsonEditorProps } from './JsonEditor.props';

/**
 * Component that generates form fields based on provided JSON schema.
 */
export const JsonEditor = (props: JsonEditorProps): JSX.Element => {
  const { data, disabled, onValidate, schema, showDescriptions, showHeader, showSubmitButton, setData, validate } =
    props;

  const [busy, setBusy] = useState<boolean>(false);

  const onChange = (event: { formData?: unknown }): void => {
    event.formData && setData(event.formData);
  };

  const editorId = useUniqueId();
  const editorClass = clsx(`sds-json-editor`, {
    [`sds-json-editor--no-descriptions`]: !showDescriptions,
    [`sds-json-editor--no-header`]: !showHeader,
    [`sds-json-editor--no-submit`]: !showSubmitButton,
  });

  useEffect(() => {
    if (validate && !busy) {
      setBusy(true);
      const editor = document.getElementById(editorId) as HTMLFormElement;
      const submitButton = editor.querySelector(`button[type="submit"]`) as HTMLButtonElement;
      submitButton.click();
    } else if (!validate && busy) {
      setBusy(false);
    }
  }, [busy, editorId, setBusy, validate]);

  return (
    <div className={editorClass}>
      <Editor
        disabled={disabled}
        formData={data}
        id={editorId}
        onChange={onChange}
        onSubmit={onValidate}
        schema={schema}
      />
    </div>
  );
};
